<template>
  <div class="page-container">
    <UiToastList/>
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/1 md:w-1/2 h-64 sm:h-64 md:h-screen"
        >
          <img
            class="w-full h-64 sm:h-64 md:h-screen object-cover object-center"
            src="@/assets/img/demo4.png"
            alt="Toyota"
          />
        </div>
        <!-- ... -->
        <div
          class="w-full sm:w-1/1 md:w-1/2 authorize-container h-auto sm:h-auto md:h-screen"
        >
          <div
            class="flex flex-col justify-center sm:min-auto min-h-full  h-full"
          >
            <h1 class="mb-8">
              <router-link :to="{ name: 'index'}" class="main-logo">
                <img src="@/assets/img/logo.png" alt="Toyota" />
              </router-link>
            </h1>
            <p class="text-left mb-8 page-title">
              Bạn quên mật khẩu
            </p>
            <div
              class="w-full sm:w-full md:w-auto form-container"
            >
                <div class="mb-4 form-controls">
                  <label
                    class="block text-sm font-bold mb-2"
                    for="username"
                  >
                    Số CMND / Mã số thuế
                  </label>
                  <input
                    class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none with-error"
                    id="username"
                    type="text"
                    placeholder="Số CMND / Mã số thuế"
                    v-model="username"
                  />
                  <p
                    :class="[ error !== '' ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    {{error}}
                  </p>
                </div>
                <!-- Just demo -->
              <div class="g-recaptcha">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    :loadRecaptchaScript="true"
                    :sitekey="recaptcha_site_key">
                  </vue-recaptcha>
                  <p
                    :class="[ pleaseTickRecaptchaMessage !== '' ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    {{pleaseTickRecaptchaMessage}}
                  </p>
                </div>
                <div>
                  <button
                    class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
                    @click="submitRequestPassword"
                  >
                    <vue-element-loading :active="isRequest"/>
                    Cấp lại mật khẩu
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueRecaptcha from 'vue-recaptcha'
import { AuthService } from '@/services/auth.service'
import UiToastList from '@/components/UiToastList'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'ForgetPassword',
  data () {
    return {
      username: '',
      recaptcha_site_key: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      error: '',
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isRequest: false
    }
  },

  methods: {
    onCaptchaVerified: function (response) {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    submitRequestPassword: function () {
      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Vui lòng xác nhận captcha'
        return
      }
      this.isRequest = true
      AuthService.resendOTPByUsername(this.username).then(response => {
        this.isRequest = false
        this.error = ''
        this.$router.push({ name: 'forgetPasswordOTP', params: { username: this.username } })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    }
  },
  components: {
    VueRecaptcha,
    UiToastList
  },
  mounted () {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('async', '')
    recaptchaScript.setAttribute('defer', '')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
  }
}
</script>

<style lang="scss" scoped>
  .g-recaptcha {
    transform: scale(1.1);
    transform-origin: 0 0;
  }
</style>
